/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface NamedTextValue
 */
export interface NamedTextValue {
    /**
     * 
     * @type {string}
     * @memberof NamedTextValue
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NamedTextValue
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof NamedTextValue
     */
    $type?: NamedTextValueTypeEnum;
}


/**
 * @export
 */
export const NamedTextValueTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNamedTextValuePtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NamedTextValue, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NamedTextValueTypeEnum = typeof NamedTextValueTypeEnum[keyof typeof NamedTextValueTypeEnum];


/**
 * Check if a given object implements the NamedTextValue interface.
 */
export function instanceOfNamedTextValue(value?: unknown): value is NamedTextValue {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NamedTextValueTypeEnum)[0];
}

export function NamedTextValueFromJSON(json: any): NamedTextValue {
    return NamedTextValueFromJSONTyped(json, false);
}

export function NamedTextValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedTextValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': json['value'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NamedTextValueToJSON(value?: NamedTextValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'value': value.value,
        '$type': value.$type,
    });
}

